import { BookOpen } from 'lucide-react';
import { CollectionAdmin } from './_P1Common';

export default function AdminBlog() {
  return (
    <CollectionAdmin
      path="blog"
      title="Blog"
      subtitle="Uredničke kolumne i osobni blogovi"
      icon={BookOpen}
      testid="admin-blog"
      fields={[
        { key: 'title', label: 'Naslov' },
        { key: 'slug', label: 'Slug' },
        { key: 'author', label: 'Autor' },
        { key: 'excerpt', label: 'Uvod', type: 'textarea' },
        { key: 'content', label: 'Sadržaj (HTML)', type: 'textarea' },
        { key: 'featured_image', label: 'URL glavne slike' },
        { key: 'published', label: 'Objavljeno', type: 'checkbox' },
      ]}
    />
  );
}
